var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h5',{staticClass:"text-black d-flex align-items-center mb-0"},[_c('img',{staticStyle:{"margin-right":"5px"},attrs:{"src":_vm.getTalentImg(_vm.talent_id),"width":"25px","height":"20px"}}),_c('b',{staticStyle:{"font-size":"18px"}},[_vm._v(_vm._s(_vm.filterName('quality',_vm.talent_id)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }